import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editSprint: {
		id: 'edit-sprint-modal-legacy-bridge.edit-sprint-button.edit-sprint',
		defaultMessage: 'Edit sprint',
		description: 'Shown on menu item, indicating Edit sprint button',
	},
});
